import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';  
import axios from '../../axios/index';

export const handleOrder = createAsyncThunk(
    'Order/handleOrder',
    async (payload, { rejectWithValue }) => {
        const { method, endpoint, data } = payload;
        try {
            const res = await axios[method](`/${endpoint}`, data && { ...data });
            // res.data?.message && alert(res.data?.message);
            return res.data;
        } catch (error) {
            if (!error.response) throw error; 
             alert(error.response.data.message);
            return rejectWithValue(error.response.data);
        }
    }
);

const initialState = {
    loading: false,
    order: JSON.parse(localStorage.getItem("order")) || null
};

export const OrderSlice = createSlice({
    name: 'Order',
    initialState,
    reducers: { },
    extraReducers: (builder) => {
        builder
            .addCase(handleOrder.pending, (state) => {
                state.loading = true;
            })
            .addCase(handleOrder.fulfilled, (state, action) => {
                state.loading = false;
                state.order = action.payload || null;
                localStorage.setItem("order",JSON.stringify(action.payload))
            })
            .addCase(handleOrder.rejected, (state, action) => {
                state.loading = false;
                // state.order = null;
            });
    },
});

export const FetchOrder = (id) => handleOrder({ method: 'get', endpoint: `order/${id}` }); 
export const CreateOrder = (data) => handleOrder({ method: 'post', endpoint: 'order/add', data }); 
export const UpdateOrder = (data) => handleOrder({ method: 'put', endpoint: 'order/update', data }); 
export const UpdateOrderStatus = (id,data) => handleOrder({ method: 'patch', endpoint: `order/${id}`, data });

export default OrderSlice.reducer;  
export const {  } = OrderSlice.actions